import { Suspense } from 'react';
import styled from 'styled-components';
import AppLoader from 'core/ui/components/AppLoader';
import { isPreviewMode, useTemplateEditorState } from '../context/UseTemplateEditorContext';
import { TemplateEditorTabs } from '../constants';
import { TemplatePreviewView } from './editor-tabs/right/template-preview/TemplatePreviewView';
import { TemplateOutputView } from './editor-tabs/right/template-output/TemplateOutputView';
import { TemplateLinksView } from './editor-tabs/right/template-links/TemplateLinksView';
import { TemplateValidationView } from './editor-tabs/right/validation/TemplateValidation';
import { PreviewRequiredView } from './editor-tabs/right/preview-required/PreviewRequiredView';
import { SnapshotInvalidView } from './editor-tabs/right/snapshot-invalid/SnapshotInvalidView';
import { Alert } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';

const RightWindowWrapper = styled.div`
  display: flex;
  border-left: ${({ theme }) => `1px solid ${theme.vars.newColor.lightGS1}`};
  height: 100%;
  width: 100%;
  flex-shrink: 1;
  flex-grow: 1;
  flex-direction: column;
`;

const RightWindowContent = styled.div`
  flex-grow: 1;
  height: 100%;
`;

const AlertContainer = styled.div`
  padding: 2em;
`;

export const TemplateEditorRightWindow = () => {
  const { activeRightTab, requiresPreview, snapshotValid, previewingVersion: versionId } = useTemplateEditorState();
  const { t } = useTranslation(['designs']);
  const getActiveTab = () => {
    switch (activeRightTab) {
      case TemplateEditorTabs.templatePreview:
        return <TemplatePreviewView />;
      case TemplateEditorTabs.templateOutput:
        return <TemplateOutputView />;
      case TemplateEditorTabs.linkOutput:
        return <TemplateLinksView />;
      case TemplateEditorTabs.codeValidation:
        return <TemplateValidationView />;
    }
  };

  const outputValidScreen = () => {
    if (!snapshotValid) {
      return <SnapshotInvalidView />;
    }

    if (requiresPreview) {
      return <PreviewRequiredView />;
    }

    return getActiveTab();
  };

  return (
    <Suspense fallback={<AppLoader />}>
      <RightWindowWrapper data-testid="TemplateEditorRightWindow">
        <RightWindowContent>{outputValidScreen()}</RightWindowContent>
        {isPreviewMode(versionId) && (
          <AlertContainer>
            <Alert
              variation="info"
              heading={t('designs:designGallery.templateEditor.versionHistory.previewMode.notification.title')}
              description={t('designs:designGallery.templateEditor.versionHistory.previewMode.notification.body')}
              onClose={() => null}
            />
          </AlertContainer>
        )}
      </RightWindowWrapper>
    </Suspense>
  );
};
